import { FormattedMessage } from 'react-intl'
import { push } from 'redux-first-history'
import { EditField } from '@starbucks-web/pattern-library'
import { useSessionCheckContext } from '../../../../../shared/app/shell/lib/session-check-provider.jsx'
import messages from './messages.js'
import { trackSettingsItemClick } from '../../../state/track-event.js'

const SettingsEditField = ({ label, labelButton, value, path, onClick }) => {
  const optionLabel = <span className="hiddenVisually">{label}</span>

  const listItems = value ? [value] : null
  const buttonLabelMessage = labelButton || messages.editLabel

  const { checkReAuthRequired } = useSessionCheckContext()

  return (
    <EditField
      buttonLabel={
        <FormattedMessage
          {...buttonLabelMessage}
          values={{
            optionLabel,
          }}
        />
      }
      listItems={listItems}
      onClick={(e) => {
        checkReAuthRequired({
          nextAction: () => {
            trackSettingsItemClick({
              click_target: label?.props?.defaultMessage,
            })
            return push({
              pathname: String(path),
            })
          },
          onCancelRedirectUrl: '/account/settings',
        })
        onClick && onClick(e)
      }}
    >
      {label}
    </EditField>
  )
}

export default SettingsEditField
